import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function reportReducer(state = initialState.report, action) {
  switch (action.type) {
    case types.LOAD_REPORT_SUCCESS:
      return action.report;
    case types.UNLOAD_REPORT_SUCCESS:
      return []; //initialState.report;
    default:
      return state;
  }
}
